/** @jsx jsx */
import * as React from "react";
import { jsx, Themed } from "theme-ui";

type SkipLinkProps = React.ComponentProps<typeof Themed.a>;

const SkipLink: React.FC<SkipLinkProps> = (props) => {
  return (
    <Themed.a
      {...props}
      sx={{
        clip: "rect(0 0 0 0)",
        height: "4px",
        width: "4px",
        margin: "-4px",
        padding: "0",
        overflow: "hidden",
        position: "absolute",
        top: "-9999px",
        transition: "none",
        "&:focus": {
          padding: "16px",
          position: "fixed",
          zIndex: 4,
          top: "0",
          left: "0",
          margin: "8px",
          fontWeight: 700,
          color: "background",
          bg: "accent",
          width: "auto",
          height: "auto",
          clip: "auto",
        },
      }}
    />
  );
};

export default SkipLink;
